import Flex from 'typescript-styled-flex'
import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const TagsList = styled(Flex as any)<IWithSize>`
  max-height: ${({ size }) => (size ? 205 * size : 205)}px;
  height: ${({ size }) => (size ? 205 * size : 205)}px;
  overflow-y: auto;
  flex-direction: column;
`

export default TagsList
